export default "__VITE_ASSET__BUdbjDrt__"